// Fonctions pures du module gestion (sans React), testées avec Vitest.

/** Mois courant au format AAAA-MM (heure locale du navigateur). */
export function currentMonth(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

/** Décale un mois AAAA-MM de `delta` mois. */
export function shiftMonth(m: string, delta: number): string {
  const [y, mo] = m.split("-").map(Number);
  const t = y * 12 + (mo - 1) + delta;
  return `${Math.floor(t / 12)}-${String((t % 12) + 1).padStart(2, "0")}`;
}

/** Valeur d'indice saisie (« 142,06 ») en centièmes (14 206) ; null si la saisie est invalide. */
export function parseIndex(s: string): number | null {
  const t = s.trim().replace(",", ".");
  if (!/^\d{2,4}(\.\d{1,2})?$/.test(t)) return null;
  const [i, d = ""] = t.split(".");
  return parseInt(i, 10) * 100 + parseInt((d + "00").slice(0, 2), 10);
}

/** Somme des affectations saisies (valeurs nulles ignorées). */
export function sumAllocations(values: Record<string, number | null>): number {
  return Object.values(values).reduce<number>((s, v) => s + (v ?? 0), 0);
}
